import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Identify() {
    return (
        <OnboardingBody title='Identifying companies that visit your site'>
            <p>
                Analyze where your prospects are located most frequently and which industries visit
                your site the most.
            </p>
            <p>
                To view all details of a company and even add it to Nutshell as a contact, ”unlock”
                it from the <strong>Companies</strong> tab.
            </p>
        </OnboardingBody>
    );
}
